import React from 'react';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { RefreshCallback } from '../../../FetchContainer';
import { PostTypes } from '../Post.types';
import { AcceptDeclineForm, HiddenParam, SonForm } from '../../../Form2';
import { Hint } from '../../Hint';

export type PostDeleteForm = SonForm<HiddenParam<'postId'>>;

type PostDeleteModalProps = {
  id: string;
  closeModal: () => void;
  type: PostTypes;
  form: PostDeleteForm;
  refresh: RefreshCallback;
};

export function PostDeleteModal({ id, closeModal, type, form, refresh }: PostDeleteModalProps) {
  const { t } = useSonTranslation('Posts');

  const onSuccess = () => {
    setTimeout(() => {
      refresh();
    }, 2000);
  };

  return (
    <ModalDialog
      key={`delete-modal-${id}`}
      initialFocusIndex={1}
      closeModal={closeModal}
      headline={t(`default.contextMenu.delete.${type}.title`)}
    >
      <AcceptDeclineForm
        id={`post-delete-form-${id}`}
        form={form}
        headline={t(`default.contextMenu.delete.${type}.headline`)}
        onSuccess={onSuccess}
        messageSuccess={t(`default.contextMenu.delete.${type}.status.success`)}
        messageSending={t(`default.contextMenu.delete.${type}.status.sending`)}
        messageFail={t(`default.contextMenu.delete.${type}.status.fail`)}
      >
        {type !== 'reply' ? <Hint message={t(`default.contextMenu.delete.${type}.hint`)} /> : null}
      </AcceptDeclineForm>
    </ModalDialog>
  );
}
